'use client';

import { createContext, useCallback, useState } from 'react';

const TransitionContext = createContext({
  completed: false,
  toggleCompleted: (value) => {},
  readyPath: null,
  readySeq: 0,
  markRouteReady: (path) => {},
});

export const TransitionProvider = ({ children }) => {
  const [completed, setCompleted] = useState(false);
  const [readyPath, setReadyPath] = useState(null);
  const [readySeq, setReadySeq] = useState(0);

  const toggleCompleted = useCallback((value) => {
    setCompleted(value);
  }, []);

  const markRouteReady = useCallback((path) => {
    setReadyPath(path);
    setReadySeq((seq) => seq + 1);
  }, []);

  return (
    <TransitionContext.Provider
      value={{
        completed,
        toggleCompleted,
        readyPath,
        readySeq,
        markRouteReady,
      }}
    >
      {children}
    </TransitionContext.Provider>
  );
};

export default TransitionContext;
